import { EXPRESS_API } from 'configs/api/expressApi';

export const removeFolderAccess = async (
  folderId: string | number
): Promise<{ message: string }> => {
  const response = await EXPRESS_API.delete(`/folders/${folderId}/access`);
  return response.data;
};
